import i18nOptions from "../../i18next.config";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import i18next from "i18next";

type Params = {
    language?: string;
};

export class i18n {
    protected loaded = false;

    async load(params: Params) {
        if (this.loaded) {
            return;
        }

        await this.loadI18next(params);

        this.loaded = true;
    }

    protected async loadI18next(params: Params) {
        await i18next
            .use(initReactI18next)
            .use(Backend)
            .init({
                ...i18nOptions,
                lng: params.language ?? i18nOptions.lng
            });
    }
}